const moment = require('moment')

const date = function (value, format = 'DD/MM/YYYY') {
  if (!value) return ''

  return moment(value).format(format)
}

const datetime = function (value, format = "DD/MM/YYYY HH:mm") {
  if (!value) return ''

  return moment(value).format(format)
}

const dateFromNow = function (value) {
  if (!value) return ''

  return moment(value).fromNow()
}

export default { date, datetime, dateFromNow }
